module.exports = __webpack_public_path__ + "static/img/label-04.58bcdb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/flash/label-04.png
// module id = s5AU
// module chunks = 150